import React from 'react';
import { Layout, Menu, Button, Tooltip } from 'antd';
import { NavLink } from 'react-router-dom';
import { ReloadOutlined } from '@ant-design/icons';

const { Header } = Layout;

const demoHeaderMenuItems = [
  {
    key: 'manageBooks',
    label: <NavLink to="/demo">My Books</NavLink>,
  },
  {
    key: 'account',
    label: <span aria-disabled="true">Account</span>,
    disabled: true,
  },
  {
    key: 'support',
    label: <span aria-disabled="true">Support</span>,
    disabled: true,
  },
  {
    key: 'about',
    label: <span aria-disabled="true">About</span>,
    disabled: true,
  },
];

const DemoHeader: React.FC = () => {
  return (
    <Header
      style={{
        padding: '0 20px',
        background: 'var(--surface-base)',
        borderBottom: '1px solid var(--border-subtle)',
        minHeight: '70px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative'
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center'
        }}
      >
        <img src="/poelogo.png" alt="logo" style={{ height: '75px' }} />
      </div>

      <Menu
        mode="horizontal"
        overflowedIndicator={null}
        items={demoHeaderMenuItems}
        style={{
          borderBottom: 'none',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          whiteSpace: 'nowrap'
        }}
      />

      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }}
      >
        <Tooltip title="Reset demo to default state">
          <Button
            size="small"
            icon={<ReloadOutlined />}
            onClick={() => window.dispatchEvent(new Event('demo:reset'))}
          >
            Reset
          </Button>
        </Tooltip>
      </div>
    </Header>
  );
};

export default DemoHeader;
